/*
  Utilities for validating data models
*/

// 7 digits + checksum
export const validateVesselImo = imo => imo && imo.length === 7 && imo[6] == (imo.split('').reduce((acc, value, index) => acc + (index < 6 && parseInt(value) * (7 - index)), 0) % 10);

// 9 digits
export const validateVesselMmsi = mmsi => mmsi && mmsi.length === 9;